import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { interval } from 'rxjs';

@Component({
  selector: 'app-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss']
})

export class SnackbarComponent implements OnInit, AfterViewInit {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any, public snackBarRef: MatSnackBarRef<SnackbarComponent>) { }

  progressbarValue = 100;
  curSec: number = 30;

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    this.startTimer(this.data?.duration || 10);
  }

  startTimer(seconds: number) {
    this.curSec = seconds;
    const timer$ = interval(1000);
    const sub = timer$.subscribe((sec) => {
      debugger;
      this.progressbarValue = 100 - ((sec + 1) * 100 / seconds);
      this.curSec--;
      if (this.curSec === 0) {
        sub.unsubscribe();
      }
    });
  }

}
